import _ from 'lodash';
import React, { Component } from 'react';
import axios from 'axios';
import DecoratedEditor from './DecoratedEditor';
import Card from '@material-ui/core/Card';


class Jazz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entries: null,
    };
    props.setActiveComponent('Jazz');
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    const res = await axios.get('/api/posts_v2?category=Jazz');
    const entries = _.get(res, 'data');
    if (entries && entries.length) {
      this.setState({ entries });
    }
  }

  render() {
    const { entries } = this.state;
    return (
      <div id="jazz">
        {_.map(entries, entry => (
          <Card className="blog-entry-card" raised>
            <DecoratedEditor entry={entry} />
          </Card>
        ))}
      </div>
    );
  }
}

export default Jazz;
